import React from 'react';
import AnalyticsContext from './AnalyticsContext';

const withAnalytics = ComponentToWrap => {
  class WithAnalyticsComponent extends React.Component {
    render = () => (
      <AnalyticsContext.Consumer>
        {context => (
          <ComponentToWrap {...this.props} analytics={context.analytics} />
        )}
      </AnalyticsContext.Consumer>
    );
  }
  return WithAnalyticsComponent;
};

export default withAnalytics;
